export class SystemColorsModel {
    static lightOrangeColors(): SystemColor {
        return new SystemColor({
            color: '#FF9800',
            bgColor: '#FFF2DF',
        });
    }

    static lightGreyColors(): SystemColor {
        return new SystemColor({
            bgColor: '#EEEEEE',
            color: '#555555',
        });
    }

    static ligthGreenColors(): SystemColor {
        return new SystemColor({
            color: '#579836',
            bgColor: '#EEF7EA',
        });
    }
    static ligthPurpleColors(): SystemColor {
        return new SystemColor({
            color: '#F2E8F2',
            bgColor: '#791C7E',
        });
    }
    static lightRedColor(): SystemColor {
        return new SystemColor({
            color: '#FF0000',
            bgColor: '#FFE5E5',
        });
    }
    static lightBlueColor(): SystemColor {
        return new SystemColor({
            color: '#6A7AB5',
            bgColor: '#ECF0FF',
        });
    }
}

export class SystemColor {
    color: string;
    bgColor: string;
    constructor(data: Partial<SystemColor>) {
        this.color = data.color || '';
        this.bgColor = data.bgColor || '';
    }
}
